import config from '../api/config'

// 手机号隐藏
// Vue.filter('phoneNumberHidden', function(phone) {
// 	var str = phone
// 	var showPhone = str.substring(0, 3) + '****' + str.substring(7);
// 	return showPhone
// })

let imgUrlConvert = function(FILEPATH) {
	var str = FILEPATH
	if (str) {
		var result = str.replace("\\", "/").replace("\\", "/")
		if (result.indexOf("http") != -1) {
			return result
		} else {
			return config.JSONIP + "/" + result
		}
	} else {
		return ''
	}

};

// //金额只显示两位
let moenyConvert = function(num) {
	var result = Math.floor(num * 100) / 100
	if (result == 0) {
		return "0.00"
	} else {
		return result.toFixed(2)
	}
}

// //图片地址转换
// Vue.filter('imgUrlConvert', function(FILEPATH) {
// 	var str = FILEPATH
// 	var result = str.replace("\\", "/").replace("\\", "/")
// 	if (result.indexOf("http") != -1) {
// 		return result
// 	} else {
// 		return config.JSONIP + "/" + result
// 	}
// })

// //金额只显示两位
// Vue.filter('moenyConvert', function(num) {
// 	var result = Math.floor(num * 100) / 100
// 	if (result == 0) {
// 		return "0.00"
// 	} else {
// 		return result
// 	}
// })
export default {
	imgUrlConvert,
	moenyConvert
}
